import { render, staticRenderFns } from "./GroupTypeBenefitEdit.vue?vue&type=template&id=78973d00&"
import script from "./GroupTypeBenefitEdit.vue?vue&type=script&lang=js&"
export * from "./GroupTypeBenefitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports